import { getServiceUrl, httpPost } from '../services/api';
import { LauncherConfig } from '../services/casino/provider-live-lobby-types';
import { CasinoProviderIntegrationNames } from '../services/casino/providers';
import { CasinoGameLauncher, CasinoProviders, EvolutionLobbyUrl, GameLaunchPosition } from '../services/casino/types';
import { getDeviceCategory } from '../services/device';
import { getLicence } from '../services/licence';
import { AppType } from '../services/mobile-app/types';
import { getRoute } from '../services/router';
import { storageGet } from '../services/storage';
import { getUserProvince } from '../services/user';
import { getUserCountry } from '../services/users/country';
import { Currency } from '../services/wallet/types';
import { stores } from '../stores';
import { casino } from '../stores/casino';
import { getStoreValue } from '../stores/store/utils';

function getUrl(url: string, provider: string) {
    return getServiceUrl(`casino-integrations-${provider}`, url);
}

function getGameLaunchSource(): GameLaunchPosition {
    // TODO: handle rendered links in blog and promotions page
    return getStoreValue(casino.latestGameLaunchPosition);
}

export async function getGameLauncherConfig(
    appType: AppType,
    gameLauncher: CasinoGameLauncher,
    config?: any,
): Promise<LauncherConfig> {
    const gameLaunchPosition: GameLaunchPosition = getGameLaunchSource();
    const isPlayForReal = getStoreValue(casino.playForReal);
    const lobbyUrl = `${window.location.origin}${getRoute(getStoreValue(casino.lastOpenedProductRoute))}`;
    const language = getStoreValue(stores.language);
    const gameParams = {
        lobbyUrl,
        gameVariantId: gameLauncher?.gameVariantId,
        platform: getDeviceCategory(appType),
        country: getUserCountry(),
        province: getUserProvince(),
        licence: getLicence(),
        deviceUuid: storageGet('uuid'),
        language,
        gameLaunchPosition,
        userCurrency: getStoreValue(stores.wallet)?.currency,
        //TODO be taken from a future dropdown
        gamePlayCurrency: gameLauncher?.gamePlayCurrency || Currency.USD,
        ...config,
    };

    const gameUrl = isPlayForReal ? 'fo/init-game-real' : 'fo/init-game-fun';

    const gameUrlResponse = await httpPost<any>(
        getUrl(gameUrl, CasinoProviderIntegrationNames[gameLauncher.providerId]),
        gameParams,
    );
    return { ...gameUrlResponse };
}

export async function getEvolutionLobbyUrl(appType: AppType): Promise<EvolutionLobbyUrl> {
    const lobbyUrl = `${window.location.origin}${getRoute(getStoreValue(casino.lastOpenedProductRoute))}`;
    const language = getStoreValue(stores.language);
    const gameParams = {
        lobbyUrl,
        platform: getDeviceCategory(appType),
        country: getUserCountry(),
        licence: getLicence(),
        deviceUuid: storageGet('uuid'),
        playMode: getStoreValue(casino.playForReal),
        province: getUserProvince(),
        language,
        userCurrency: getStoreValue(stores.wallet)?.currency,
        gamePlayCurrency: Currency.USD,
    };

    const lobbyUrlResponse = await httpPost<EvolutionLobbyUrl>(
        getUrl('fo/init-game-lobby', CasinoProviderIntegrationNames[CasinoProviders.EVOLUTION]),
        gameParams,
    );
    return { ...lobbyUrlResponse };
}

export async function getProviderLiveLobbyLauncherConfig(
    appType: AppType,
    gameLauncher: CasinoGameLauncher,
): Promise<LauncherConfig | null> {
    const lobbyUrl = `${window.location.origin}${getRoute(getStoreValue(casino.lastOpenedProductRoute))}`;

    if (!gameLauncher.type) {
        return null;
    }

    const requestPayload = {
        country: getUserCountry(),
        language: getStoreValue(stores.language),
        platform: getDeviceCategory(appType),
        licence: getLicence(),
        deviceUuid: storageGet('uuid'),
        playMode: getStoreValue(casino.playForReal),
        province: getUserProvince(),
        lobbyUrl,
        liveLobbyData: { lobbyType: gameLauncher.type.toUpperCase(), subproviderId: gameLauncher.subProviderId },
        userCurrency: getStoreValue(stores.wallet)?.currency,
        gamePlayCurrency: Currency.USD,
    };

    return httpPost<LauncherConfig>(
        getUrl('fo/init-live-lobby', CasinoProviderIntegrationNames[gameLauncher.providerId]),
        requestPayload,
    );
}
